/**
 * SPA usually shares origin with Express (Docker / nginx). Local dev relies on CRA "proxy".
 * Split hosts: REACT_APP_API_ORIGIN=http://127.0.0.1:8082 — no trailing slash.
 */
export function getApiOrigin(): string {
  return (process.env.REACT_APP_API_ORIGIN || '').trim().replace(/\/+$/, '')
}

/** Absolute-ish path for fetch: same-origin by default */
export function apiUrl(path: string): string {
  const base = getApiOrigin()
  const p = path.startsWith('/') ? path : `/${path}`
  return base ? `${base}${p}` : p
}
